import {
  LOGIN,
  LOGOUT,
  RESTORE_TOKEN,
  SKIP_ONBOARDING,
  GET_ME,
  GET_USER_ACCOUNTS,
  GET_CONNECTIONS,
  SET_THEME,
} from './types';
import { rejected, resolved } from '../../createAction';

const initialState = {
  isLoggedIn: false,
  token: null,
  user: {},
  connections: [],
  accounts: [],
  darkMode: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN: {
      return {
        ...state,
        ...payload,
        isLoggedIn: true,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isLoggedIn: false,
        token: null,
        user: {},
      };
    }
    case RESTORE_TOKEN: {
      return {
        ...state,
        ...payload,
        isLoggedIn: true,
      };
    }
    case rejected(LOGIN): {
      return {
        ...state,
        isLoggedIn: false,
      };
    }
    case resolved(GET_ME):
      return {
        ...state,
        user: payload,
        isLoggedIn: true,
      };
    case resolved(SKIP_ONBOARDING): {
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
        },
      };
    }
    case resolved(GET_USER_ACCOUNTS): {
      return {
        ...state,
        accounts: payload,
      };
    }
    case resolved(GET_CONNECTIONS): {
      return {
        ...state,
        connections: payload,
      };
    }
    case SET_THEME: {
      return {
        ...state,
        darkMode: payload,
      };
    }
    default:
      return state;
  }
};
